import React from "react";
import appimage from '../img/appimg.gif'
import { CONTACT_FORM_URL, GOOGLE_FORM_URL } from "./AppConstant";

const AppDevelopment = () => {
  return (
    <div className="container-fluid py-5 bg-light">
      <div className="container">
        <div className="row align-items-center g-5">
          {/* Image Section */}
          <div className="col-lg-6 wow fadeInLeft" data-wow-delay="0.3s">
            <img
              className="img-fluid rounded"
              src={appimage}
              alt="Mobile App Development"
            />
          </div>
          {/* Text Section */}
          <div className="col-lg-6 wow fadeInRight" data-wow-delay="0.6s">
            <h2 className="mb-4 text-primary">Custom Mobile App Development</h2>
            <p className="mb-4">
              At <strong>Aesos</strong>, we specialize in building powerful, scalable, and user-friendly mobile applications tailored for startups, enterprises, and businesses. Our team of expert developers brings your ideas to life with seamless performance across Android and iOS platforms.
            </p>
            <ul className="list-unstyled mb-4">
              <li><i className="fa fa-check-circle text-secondary me-2"></i>Android & iOS App Development</li>
              <li><i className="fa fa-check-circle text-secondary me-2"></i>UI/UX Design & Prototyping</li>
              <li><i className="fa fa-check-circle text-secondary me-2"></i>Cross-Platform Apps with Flutter/React Native</li>
              <li><i className="fa fa-check-circle text-secondary me-2"></i>App Store Deployment & Support</li>
            </ul>
            <a href='/contact' className="btn btn-primary px-4 py-2">
              contact
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppDevelopment;
